export default __webpack_public_path__ + "static/media/1182.b49ece29.png";